import React, { useEffect, useRef, useState } from "react";
import HeroSection from "./HeroSection/HeroSection";

import "./Landingpage.scss";
import { logout } from "../../utils/services/auth";
import { useLocation } from "react-router-dom";
import { LoginDialog } from "../../dialogs";
import { useChain } from "@cosmos-kit/react";

function Landingpage() {
  const [openLoginDialog, setLoginDialog] = useState(false);
  const [redirectLink, setRedirectLink] = useState<string>("/dashboard");
  const PageRefs = useRef<any>([null, null, null, null]);
  const _location = useLocation();
  const cosmoskitDialog = useChain("cosmoshub");

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
      if (_location?.state?.from === "viewFile") {
        setRedirectLink(_location?.state?.to || "/dashboard");
        setLoginDialog(true);
      } else {
        localStorage.getItem("reloadKey")
          ? localStorage.removeItem("reloadKey")
          : localStorage.setItem("reloadKey", "1");
        let isReloaded = localStorage.getItem("reloadKey");
        isReloaded &&
          _location?.state?.from === "logout" &&
          window.location.reload();

        (async () => {
          await logout();
        })();
      }

      // checking refrence link and creating localstorage variable
      const urlParams = new URLSearchParams(window.location.search);
      const referBy:string|null = urlParams.get("referBy");
      const redirectFrom = urlParams.get("redirectfrom");
      if (referBy && referBy !== undefined ) {
        localStorage.setItem("files.lighthouse.storage/referBy", referBy);
      }
      if (redirectFrom !== undefined && redirectFrom === 'main') {
        setLoginDialog(true);
      }
    }
    return () => {
      componentMounted = false;
    };
  }, []);


  return (
    <>
     <div className="landingPage">
        {/* <LandingHeader PageRefs={PageRefs} setLoginDialog={setLoginDialog} /> */}
        <div
          className="landingPage__HeroSection"
          ref={(element) => {
            PageRefs.current[0] = element;
          }}
        >
          <HeroSection setLoginDialog={setLoginDialog} loginRediect={redirectLink} cosmoskitDialog={cosmoskitDialog} />
        </div>
        {/* <div
          className="landingPage__FeatureSection"
          ref={(element) => {
            PageRefs.current[1] = element;
          }}
        >
          <Features />
        </div>
        <div
          className="landingPage__FeatureSection"

        >
          <PartnerCarousel />
        </div>
        <div
          className="landingPage__FeatureSection"
          ref={(element) => {
            PageRefs.current[2] = element;
          }}
        >
          <PricingPage />
        </div>
        <div
          className="landingPage__FAQSection"
          ref={(element) => {
            PageRefs.current[3] = element;
          }}
        >
          <FAQ />
        </div> */}
      </div> 
    </>
  );
}

export default Landingpage;
